import React, { useState } from 'react';
import axios from 'axios'
import { Label, TextInput } from 'flowbite-react';
import { UserAuth } from '../Context/AuthContext';

export default function UserAddForm({gladiator_id}) {
const [name,setName]=useState("")
const [email,setEmail]=useState("")
const [phone,setPhone]=useState("")
const [nameBangla,setNameBangla]=useState("")
const [address,setAdddress]=useState("")
const [addressBangla,setAdddressBangla]=useState("")
const [image,setImage]=useState("https://i.postimg.cc/X7Pmn07P/image.png")
const baseURL="https://mukti-backend-bd.onrender.com"
const formURL=`${baseURL}/user`

const {createUser} =UserAuth()
const submitForm =()=>{
    const newUser = axios.post(formURL,{
        name,
        name_bangla:nameBangla,
        email,
        phone,
        user_type:"Normal",
        user_type_bangla:"সাধারন",
        address,
        address_bangla:addressBangla,
        image
      
    }).then((newUser)=>{
        
        console.log(newUser)
        axios.post(`${baseURL}/gau`,{
            gladiator_id,
            user_id:newUser.data.user_id
        })    

    }).then(()=>{
    createUser(email,123456)
      alert("Successfully Added User")

    })
    .catch(()=>{
      alert("Adding user failed")

  })
  }
  return (
    <div className="flex justify-center items-center mx-8 mb-24 flex-col gap-4">

      <TextInput value={name} type="text" onChange={e=>setName(e.target.value)} className='w-full' placeholder='Full Name (ENGLISH)'/>

      <TextInput value={nameBangla} type="text" onChange={e=>setNameBangla(e.target.value)} className='w-full' placeholder='Full Name (BANGLA)'/>

      <TextInput value={email} type="text" onChange={e=>setEmail(e.target.value)} className='w-full' placeholder='Email Address'/>

      <TextInput value={phone} type="text" onChange={e=>setPhone(e.target.value)} className='w-full' placeholder='Phone Number'/>

      <TextInput value={address} type="text" onChange={e=>setAdddress(e.target.value)} className='w-full' placeholder='Address (ENGLISH)'/>

      <TextInput value={addressBangla} type="text" onChange={e=>setAdddressBangla(e.target.value)} className='w-full' placeholder='Address (BANGLA)'/>

      <TextInput value={image} type="text" onChange={e=>setImage(e.target.value)} className='w-full' placeholder='Image URL'/>
      <button onClick={submitForm} class="inline-flex text-center items-center text-white bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:focus:ring-primary-900">
             Add User
    </button>
    </div>
  )
}



